import { render, staticRenderFns } from "./AppAvatanPermission.vue?vue&type=template&id=30d594aa&scoped=true&"
import script from "./AppAvatanPermission.vue?vue&type=script&lang=js&"
export * from "./AppAvatanPermission.vue?vue&type=script&lang=js&"
import style0 from "./AppAvatanPermission.vue?vue&type=style&index=0&id=30d594aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d594aa",
  null
  
)

export default component.exports